module.exports = __webpack_public_path__ + "static/media/parrot.4044a517.png";